import React, { useRef, useState, useEffect } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';


import ColorPicker from './ColorPicker';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import api from '../api/api';

import '../layout/sass/_form.scss';
import { Dropdown } from 'primereact/dropdown';




export const FormTipoCursos = ({ isEditing, isLoading, defaultValues }) => {

    const history = useHistory();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false)

    const [colorHEX, setColorHEX] = useState('#BFEFFF');

    const schema = Yup.object().shape({
        nome: Yup
            .string()
            .required("O nome é obrigatório")
            .max(200, "O nome dete ter no máximo 200 caracteres"),
        cor: Yup
            .string()
            .required("A côr é obrigatório")
    })

    useEffect(() => {
        if (isEditing && defaultValues && defaultValues.cor) {
            setColorHEX(defaultValues.color);
        }
    }, [isEditing, defaultValues]);

    useEffect(() => {
        formik.setFieldValue('cor', colorHEX);
    }, [colorHEX]);


    const formik = useFormik({

        initialValues: defaultValues,

        validationSchema: schema,

        enableReinitialize: true,

        onSubmit: async (data) => {
            setIsSubmiting(true)

            formik.setFieldValue("cor", colorHEX);

            try {
                if (!isEditing) {
                    await api.post("tipo-cursos", data)

                    formik.resetForm()
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `${data.nome} adicionado(a) com sucesso` });
                    setTimeout(() => {
                        history.push('/tipoCursos')

                    }, 2000)

                }
                else {
                    await api.put(`tipo-cursos/${data.id}`, data)

                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `${data.nome} atualizado(a) com sucesso` });
                    setTimeout(() => {

                        history.push('/tipoCursos')

                    }, 2000)
                }
            }
            catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar curso!', detail: error.toString() });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar curso!', detail: error.toString() });

            }

            setIsSubmiting(false)
        }
    })

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">
                    <h2 className="p-mt-0">Tipo Cursos</h2>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">
                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="nome"
                                    className={classNames({ 'p-error': isFormFieldValid('nome') })}
                                >
                                    Nome
                                </label>
                                {
                                    !isLoading ?
                                        <InputText
                                            id="nome"
                                            name="nome"
                                            className={classNames({ 'p-invalid': isFormFieldValid('nome') })}
                                            value={formik.values.nome}
                                            onChange={formik.handleChange}
                                        />
                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.nome && formik.touched.nome &&
                                    <ErrorValidationMessage message={formik.errors.nome} />
                                }
                            </div>

                            <div className="p-field p-col-12 p-sm-4">
                                <label htmlFor="cp-hex"
                                    className={classNames({ 'p-error': isFormFieldValid('cor') })}
                                >
                                    Côr
                                </label>
                                {
                                    !isLoading ?

                                        <div >
                                            <ColorPicker cor={colorHEX} setCor={setColorHEX} />
                                        </div>

                                        :
                                        <Skeleton height="35px" />
                                }
                                {formik.errors.cor && formik.touched.cor &&
                                    <ErrorValidationMessage message={formik.errors.cor} />
                                }
                            </div>

                        </div>
                        <div className="p-d-flex p-jc-end p-mr-1">
                            {
                                !isLoading ?
                                    <Button
                                        label={isEditing ? 'Atualizar' : 'Salvar'}
                                        type="submit"
                                        iconPos="right"
                                        loading={isSubmiting}
                                    />
                                    :
                                    <Skeleton width="82.16px" height="35px" />

                            }
                        </div>
                    </form>
                </div>
                {/* <div className="p-col-12">
                { 
                    isEditing ?
                        <TabelaTurmasCurso
                            turmasCurso={defaultValues.id}
                        />
                    :
                        <></>
                }
                
            </div> */}
            </div>

        </>
    );
}